<template>
	<!-- 公共头部 -->
	<div class="common black">
		<div class="footer">
			<div class="footerLeft">
				<p>联系方式</p>
				<p class="contact">CONTACT</p>
			</div>
			<div class="footerCenter">
				<p>联系电话：150-9888-8978   139-6959-9105</p>
				<P>客服电话：400-6895223</P>
				<P>地址：庐山路产业园</P>
				<P>网址：www.htc86.com</P>
			</div>
			<div class="footerRight">
				<div class="font">
					<p>扫描关注我们</p>
					</p>获取更多服务</p>
				</div>
				<img src="../assets/images/weixin.png" alt="" class="weixin">
			</div>
		</div>
		<div class="bottom">
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.black{
		background: #000000;
	}
	.footer{
		height: 140px;
		padding: 50px  0 30px 0;
		width:1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		.footerLeft{
			width: 165px;
			color: #fff;
			text-align: left;
			font-size: 28px;
			.contact{
				font-size: 20px;
				margin-top: 18px;
			}
		}
		.footerCenter{
			font-size: 14px;
			color: #cbcbcb;
			text-align: left;
			width:790px;
			p{
				height: 28px;
				line-height: 28px;
			}
		}
		.footerRight{
			width: 245px;
			display: flex;
			justify-content: space-between;
			flex-direction: row;
			.font{
				font-size: 14px;
				color: #cbcbcb;
				height: 108px;
				border: 1px solid #cbcbcb;
				width: 134px;
				display: flex;
				align-items: center;
				flex-direction: column;
				justify-content: center;
			}
			.weixin{
				width:110px ;
				height: 110px;
			}
		}
	}
	.bottom{
		height: 15px;
		background: #1c263a;
		width:100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue